const currencySorter = (a, b) => parseFloat(a) - parseFloat(b);

export default currencySorter;
